import React from 'react';
import './styles.less';
import PropTypes from 'prop-types';

const MarkerCell = ({ field, row }) => {
	return (
		// eslint-disable-next-line
		<a target="_blank" rel="noreferrer noopener" href={row[field]} className="marker-cell">
			<span className="marker-cell__text" />
		</a>
	);
};

MarkerCell.propTypes = {
	row: PropTypes.object.isRequired,
	field: PropTypes.string.isRequired,
};

export { MarkerCell };
